import { request } from './request';

export const getReferralById = (id) => request(`referrals/${id}`);

export const createReferral = (body) =>
  request(`referrals`, {
    method: 'POST',
    body,
  });
